(function () {
  if (window.__aiPdpInit) return;
  window.__aiPdpInit = true;

  /* Size guide dialog */
  document.addEventListener('click', function (e) {
    var openBtn = e.target.closest('.ai-sg__btn');
    if (openBtn) {
      var dlg = openBtn.closest('.ai-sg').querySelector('.ai-sg__dialog');
      if (dlg && typeof dlg.showModal === 'function') dlg.showModal();
      return;
    }
    var closeBtn = e.target.closest('.ai-sg__close');
    if (closeBtn) { closeBtn.closest('dialog').close(); return; }
    if (e.target.classList && e.target.classList.contains('ai-sg__dialog')) {
      var r = e.target.getBoundingClientRect();
      if (e.clientX < r.left || e.clientX > r.right || e.clientY < r.top || e.clientY > r.bottom) e.target.close();
      return;
    }
    var unit = e.target.closest('.ai-sg__unit');
    if (unit) {
      var dialog = unit.closest('.ai-sg__dialog');
      dialog.querySelectorAll('.ai-sg__unit').forEach(function (b) { b.classList.toggle('is-active', b === unit); });
      var table = dialog.querySelector('.ai-sg__table');
      if (table) table.setAttribute('data-unit', /cm/i.test(unit.textContent) ? 'cm' : 'in');
    }
  });

  /* Smooth accordions on the product page */
  function smooth(details) {
    if (details.__aiSmooth) return;
    details.__aiSmooth = true;
    details.setAttribute('data-ai-smooth', '1');
    var summary = details.querySelector('summary');
    var content = details.querySelector('.accordion__content');
    if (!summary || !content) return;
    summary.addEventListener('click', function (e) {
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      e.preventDefault();
      if (details.open) {
        details.setAttribute('data-ai-closing', '1');
        var h = content.offsetHeight;
        content.animate([{ height: h + 'px' }, { height: '0px' }], { duration: 300, easing: 'cubic-bezier(0.4,0,0.2,1)' }).onfinish = function () {
          details.open = false; details.removeAttribute('data-ai-closing'); summary.setAttribute('aria-expanded', 'false');
        };
      } else {
        details.open = true; summary.setAttribute('aria-expanded', 'true');
        var target = content.offsetHeight;
        content.animate([{ height: '0px' }, { height: target + 'px' }], { duration: 300, easing: 'cubic-bezier(0.4,0,0.2,1)' });
      }
    });
  }
  function initAccordions(root) { (root || document).querySelectorAll('.product__info-container .product__accordion details').forEach(smooth); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAccordions(); }); else initAccordions();
  document.addEventListener('shopify:section:load', function (e) { initAccordions(e.target); });

  /* Image colour swatches: select the matching option in Dawn's (hidden) picker */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.ai-pdp-swatch__item');
    if (!btn) return;
    var wrap = btn.closest('[data-ai-swatch]');
    if (!wrap) return;
    var name = wrap.getAttribute('data-option');
    var value = btn.getAttribute('data-value');
    wrap.querySelectorAll('.ai-pdp-swatch__item').forEach(function (b) {
      var on = b === btn;
      b.classList.toggle('is-selected', on);
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
    var label = wrap.querySelector('[data-ai-swatch-value]');
    if (label) label.textContent = value;
    var scope = btn.closest('product-info') || document;
    var inputs = scope.querySelectorAll('variant-selects input[type="radio"]');
    for (var i = 0; i < inputs.length; i++) {
      var inp = inputs[i];
      if (inp.name.trim().indexOf(name + '-') === 0 && inp.value === value) {
        if (!inp.checked) { inp.checked = true; inp.dispatchEvent(new Event('change', { bubbles: true })); }
        break;
      }
    }
  });
})();

/* Keep the selected thumbnail visible inside the scrolling thumbnail column */
(function(){
  if (window.__aiThumbScroll) return; window.__aiThumbScroll = true;
  function sync(){
    document.querySelectorAll('main media-gallery > slider-component[id^="GalleryThumbnails"]').forEach(function(box){
      var cur = box.querySelector('[aria-current]');
      if (!cur) return;
      var li = cur.closest('li') || cur;
      var top = li.getBoundingClientRect().top - box.getBoundingClientRect().top + box.scrollTop, bottom = top + li.offsetHeight;
      if (top < box.scrollTop) box.scrollTop = top;
      else if (bottom > box.scrollTop + box.clientHeight) box.scrollTop = bottom - box.clientHeight;
    });
  }
  function init(){
    var g = document.querySelector('main media-gallery');
    if (!g) return;
    new MutationObserver(function(){ requestAnimationFrame(sync); }).observe(g, { subtree: true, attributes: true, attributeFilter: ['aria-current'] });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();

/* Mobile: sticky "add to cart" bar once the main button has scrolled out of view */
(function(){
  if (window.__aiStickyAtc) return; window.__aiStickyAtc = true;
  function init(){
    var info = document.querySelector('main product-info');
    var main = info && info.querySelector('.product-form__submit');
    if (!main) return;
    var mq = window.matchMedia('(max-width: 749px)');
    var css = document.createElement('style');
    css.textContent = '.ai-satc{position:fixed;left:0;right:0;bottom:0;z-index:40;display:flex;align-items:center;gap:12px;padding:10px 14px calc(10px + env(safe-area-inset-bottom));background:#fff;box-shadow:0 -4px 18px rgba(0,0,0,.10);transform:translateY(110%);transition:transform .25s ease;font-family:var(--font-body-family)}'
      + '.ai-satc.is-on{transform:translateY(0)}'
      + '.ai-satc__info{flex:1;min-width:0;line-height:1.25}'
      + '.ai-satc__price{font-size:16px;font-weight:600;color:#000}'
      + '.ai-satc__opts{font-size:12px;color:#555;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}'
      + '.ai-satc__btn{flex:0 0 auto;min-height:46px;padding:0 18px;border:0;background:#652734;color:#fff;font-family:inherit;font-size:12px;font-weight:700;letter-spacing:.18em;text-transform:uppercase;cursor:pointer}'
      + '.ai-satc__btn[disabled]{opacity:.5;cursor:default}'
      + '@media (min-width:750px){.ai-satc{display:none}}';
    document.head.appendChild(css);
    var bar = document.createElement('div');
    bar.className = 'ai-satc';
    bar.setAttribute('aria-hidden', 'true');
    bar.innerHTML = '<div class="ai-satc__info"><div class="ai-satc__price"></div><div class="ai-satc__opts"></div></div><button type="button" class="ai-satc__btn" tabindex="-1"></button>';
    document.body.appendChild(bar);
    var priceEl = bar.querySelector('.ai-satc__price'), optsEl = bar.querySelector('.ai-satc__opts'), btn = bar.querySelector('.ai-satc__btn');
    function sync(){
      var m = info.querySelector('.product-form__submit') || main;
      main = m;
      var label = (m.querySelector('span') || m).textContent.trim();
      btn.textContent = label;
      btn.disabled = m.disabled || m.hasAttribute('disabled');
      var p = info.querySelectorAll('.ai-pdp-price .product__price');
      priceEl.textContent = p.length ? p[p.length - 1].textContent.trim() : '';
      var opts = [];
      var sw = info.querySelector('[data-ai-swatch-value]');
      if (sw) opts.push(sw.textContent.trim());
      info.querySelectorAll('variant-selects fieldset').forEach(function(fs){
        if (sw && fs.offsetParent === null) return;
        var c = fs.querySelector('input:checked');
        if (c) opts.push(c.value);
      });
      optsEl.textContent = opts.join(' · ');
    }
    var on = false;
    function show(v){
      v = v && mq.matches;
      if (v === on) return;
      on = v;
      if (v) sync();
      bar.classList.toggle('is-on', v);
      bar.setAttribute('aria-hidden', v ? 'false' : 'true');
      btn.tabIndex = v ? 0 : -1;
    }
    function check(){
      var r = main.getBoundingClientRect();
      var footer = document.querySelector('.cr-ft, footer');
      var nearEnd = footer && footer.getBoundingClientRect().top < window.innerHeight;
      show(r.bottom < 0 && !nearEnd);
    }
    window.addEventListener('scroll', check, { passive: true });
    window.addEventListener('resize', check);
    new MutationObserver(function(){ if (on) sync(); }).observe(info, { subtree: true, childList: true, characterData: true, attributes: true, attributeFilter: ['disabled', 'class'] });
    btn.addEventListener('click', function(){
      var m = info.querySelector('.product-form__submit');
      if (!m || m.disabled) return;
      m.click();
    });
    check();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
